import React from "react";
import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";

import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3, 2)
  },
  button: {
    margin: theme.spacing(1)
  }
}));

export default function Past(props) {
  const classes = useStyles();
  return (
    <Container style={{ marginTop: 82 }}>
      <Grid container spacing={2}>
        {props.prev.map(e => {
          return (
            <Grid item xs={12} sm={6} lg={4} key={e.bookingId}>
              <Link
                to={{
                  pathname:
                    "/food-booking/orderdetails/" + e.bookingId + "/" + e.Status
                }}
                style={{ textDecoration: "none" }}
              >
                <Paper
                  className={classes.root}
                  style={{
                    marginBottom: 5,
                    backgroundImage: "linear-gradient(to right,#F1F1F1,white)"
                  }}
                >
                  <Grid
                    container
                    spacing={2}
                    style={{ overflowWrap: "break-word" }}
                  >
                    <Grid item xs={12}>
                      <Grid container>
                        <Grid item xs={6} style={{ color: "#999999" }}>
                          BookingID
                        </Grid>
                        <Grid item xs={6}>
                          {e.bookingId}
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={12}>
                      <Grid container>
                        <Grid item xs={6} style={{ color: "#999999" }}>
                          BookingDate
                        </Grid>
                        <Grid item xs={6}>
                          {e.bookingDate}
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={12}>
                      <Grid container>
                        <Grid item xs={6} style={{ color: "#999999" }}>
                          Status
                        </Grid>
                        <Grid item xs={6}>
                          {e.Status}
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={12}>
                      <Grid container>
                        <Grid item xs={6} style={{ color: "#999999" }}>
                          PhoneNumber
                        </Grid>
                        <Grid item xs={6}>
                          {e.PhoneNumber}
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item xs={12}>
                      <Grid container>
                        <Grid item xs={6} style={{ color: "#999999" }}>
                          Email
                        </Grid>
                        <Grid item xs={6} style={{ float: "right" }}>
                          {e.Email}
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={12}>
                      <Grid container>
                        <Grid item xs={6} style={{ color: "#999999" }}>
                          DeliveryDate
                        </Grid>
                        <Grid item xs={6}>
                          {e.deliveryDate}
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Paper>
              </Link>
            </Grid>
          );
        })}
      </Grid>
    </Container>
  );
}
